import { Badge as FluentBadge } from "@fluentui/web-components";
/**
 * Badge
 * @summary A badge component representing a small count or label, often used to show status, categorization, or decorative purposes.
 *
 * @example
 * ```html
 * <fabric-badge appearance="filled" color="brand" shape="rounded" size="medium">
 *   <span slot="start">🌟</span>
 *   2
 *   <span slot="end">🔔</span>
 * </fabric-badge>
 * ```
 *
 * @attr {BadgeAppearance} appearance - The appearance the badge should have. One of: 'outline', 'filled', 'ghost', 'tint'.
 * @attr {BadgeColor} color - The color the badge should have. One of: 'subtle', 'brand', 'danger', 'important', 'informative', 'severe', 'success', 'warning'.
 * @attr {BadgeShape} shape - The shape the badge should have. One of: 'circular', 'rounded', 'square'.
 * @attr {BadgeSize} size - The size the badge should have. One of: 'tiny', 'extra-small', 'small', 'medium', 'large', 'extra-large'.
 *
 * @prop {BadgeAppearance} appearance - The appearance the badge should have. One of: 'outline', 'filled', 'ghost', 'tint'.
 * @prop {BadgeColor} color - The color the badge should have. One of: 'subtle', 'brand', 'danger', 'important', 'informative', 'severe', 'success', 'warning'.
 * @prop {BadgeShape} shape - The shape the badge should have. One of: 'circular', 'rounded', 'square'.
 * @prop {BadgeSize} size - The size the badge should have. One of: 'tiny', 'extra-small', 'small', 'medium', 'large', 'extra-large'.
 *
 * @slot start - Content to be placed at the start of the badge.
 * @slot - Default slot for the badge content.
 * @slot end - Content to be placed at the end of the badge.
 *
 * @method appearanceChanged - Handles changes to appearance attribute custom states.
 * @method colorChanged - Handles changes to color attribute custom states.
 * @method shapeChanged - Handles changes to shape attribute custom states.
 * @method sizeChanged - Handles changes to size attribute custom states.
 *
 * @extends FluentBadge
 * @tagname fabric-badge
 * @public
 */
export class Badge extends FluentBadge {
}
//# sourceMappingURL=badge.js.map